import React, { useMemo } from "react";
import { Row, Col } from 'reactstrap';

import CheckListProcessEntityTable from "../../../check_list/process/entity_table";
import { fetchCustomFieldValue, isAuthorizedCustomFieldToUser } from "../../../helper/custom_field/helper";

const CorporateCheckListAgreementProcessEntityTable = props => {
  const {
    currentUser,
    data,
    checkListEntities,
    callbacks:{
      callbackHandleProcessData
    },
    errors
  } = props;

  const {
    companies,
    customFields,
  } = data;

  const tableColumnsDefault = [
    {
      field: 'agreement_config.client.company_config.name"',
      header: I18n.t('activerecord.attributes.corporate/agreement_config.client_id'),
      body: (row) => {
        return row?.agreement_config?.client?.company_config?.name || I18n.t('no_entry');
      },
      filter: {
        enabled: true,
        placeholder: 'Seleccione una empresa',
        inputType: 'simple_select',
        filterrific: {
          search: 'by_client',
        },
        options: _.map(companies, company => ({
          value: company.id,
          label: company.name,
        })),
      },
    },
    {
      field: 'agreement_config.provider.company_config.name"',
      header: I18n.t('activerecord.attributes.corporate/agreement_config.provider_id'),
      body: (row) => {
        return row?.agreement_config?.provider?.company_config?.name || I18n.t('no_entry');
      },
      filter: {
        enabled: true,
        placeholder: 'Seleccione una empresa',
        inputType: 'simple_select',
        filterrific: {
          search: 'by_provider',
        },
        options: _.map(companies, company => ({
          value: company.id,
          label: company.name,
        })),
      },
    },
    {
      field: 'start_date_to_s',
      header: I18n.t('activerecord.attributes.corporate/agreement_config.start_date'),
    },
    {
      field: 'end_date_to_s',
      header: I18n.t('activerecord.attributes.corporate/agreement_config.end_date'),
      body: (row) => {
        return row?.end_date_to_s || 'Indefinido';
      },
    },
  ]

  const tableColumnsCustomFields = useMemo(() => {
    return _.map(customFields, function (customField) {
      return {
        field: `custom_fields.${ customField.code }`,
        header: _.capitalize(customField.label),
        body: (row) => {
          return fetchCustomFieldValue(customField, row.custom_fields[customField.code], currentUser)
        },
        filter: {
          enabled: true,
          placeholder: `Ingrese ${ _.capitalize(customField.label) }`,
          filterrific: {
            search: `search_by_key_custom_fields`,
            searchKey: customField.code
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [])

  const tableColumns = useMemo(() => {
    let columns = _.concat(
      tableColumnsDefault,
      tableColumnsCustomFields
    )

    return _.compact(columns)
  }, [])

  return(
    <Row>
      <Col md={12}>
        <CheckListProcessEntityTable
          checkListEntities={ checkListEntities }
          dataTableConfiguration={{
            columns: tableColumns
          }}
          configuration={{
            showDistributionListFilter: false,
            entityKey: 'agreements',
            defaultRequestParams: {},
            context: 'corporate'
          }}
          routes = {{
            indexEntitiesPath: Routes.corporate_agreements_path
          }}
          callbacks={{
            callbackHandleProcessData: callbackHandleProcessData
          }}
          errors={ errors }
        />
      </Col>
    </Row>
  )
}

export default CorporateCheckListAgreementProcessEntityTable
